import { PipelinesLegacyRedirect } from './-components';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/pipelines/workspaces/$workspaceId/')({
  component: PipelinesLegacyRedirect,
});
